import React, { Component } from 'react';
import { HeaderText } from '@Elements';

export default class Header extends Component {
  render() {
    return (
      <HeaderText>
        Sliding Puzzle
      </HeaderText>
    );
  }
}
